import useGetApi from 'api/useGetApi';
import { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import CONFIG from '../../config'
import { Container } from 'reactstrap'
import QualifiedCard from 'components/Result/Qualified/QualifiedCard';
import Branchmapsection from 'components/branchDetails/branch_map_section';
import NeetChampionBanner from 'components/MoreInfoSection/NeetChampionBanner';
import Byjus_Advantage from 'components/MoreInfoSection/byjus_advantage';
import Faq from 'components/MoreInfoSection/faq';
import CourseListing from 'components/MoreInfoSection/CourseListing'
import NonqualifiedCard from 'components/Result/NonQualified/NonqualifiedCard';
import Loader from 'components/Result/AntheResults/components/Loader';
import { courseListing } from 'api/api';
import GuidedJourney from 'components/ECommerce/GuidedJourney';
import Fomo from 'components/ECommerce/Fomo';
import ResultWavier from 'components/ECommerce/ResultWavier';
import { SET_DASHBOARD_API_DATA, SET_TP_RESULT_DATA } from 'constants/actionTypes';

import { params as webengage_params } from '../../utils/customWebengageEvents'
import TestServerDownMsg from 'components/Card/TestServerDownMsg';
import ResultAwaitedCase from 'components/Card/ResultAwaitedCase';
import Faqtwo from 'components/MoreInfoSection/faqtwo';

const mapStateToProps = (state) => {
    return {
        token: state?.token,
        profileInfo: state?.profileData,
        dashboardInfo: state?.dashboardData
    }
}

const mapDispatchToProps = (dispatch) => ({
    setTpResultData: (payload) => {
        dispatch({ type: SET_TP_RESULT_DATA, payload: payload })
    },
    setDashboardData: (payload) => {
        dispatch({ type: SET_DASHBOARD_API_DATA, payload: payload })
    }
});

const ResultPage = (props) => {
    const [tpToken, setTpToken] = useState();
    const [CourseData, setCourseData] = useState();
    const [isProductLoading, setisProductLoading] = useState(false);

    // API CALL FOR Getting token
    const {
        data: tpTokenData,
        loading: isTokenLoading,
        tokenError,
        setEnabled: setTPTokenEnabled,
    } = useGetApi(CONFIG.TP_TOKEN_API, '', true, CONFIG.TP_TOKEN_API_TOKEN);

    //api call for getting student result
    const {
        data: tpResultData,
        loading: isResultLoading,
        error: resultErrors,
        setEnabled: setTPDataEnabled,
    } = useGetApi(CONFIG.TP_RESULT_DATA + `?rollNo=${props?.profileInfo?.roll_number}`, '', false, tpToken);

    const [isLoader, setIsLoading] = useState(isTokenLoading || isResultLoading || true);

    useEffect(() => {
        if (tpTokenData && tpTokenData.data !== '') {
            setTpToken(tpTokenData.data);
            setTPDataEnabled(true);
        }
    }, [tpTokenData]);

    useEffect(() => {
        if (tpResultData && tpResultData.data !== '') {
            webengage_params.scholarship_waiver_message = tpResultData?.data?.scholarship?.remarks;
            webengage_params.grade = tpResultData?.data?.grade;
            webengage_params.anthe_rank_city = tpResultData?.data?.scholarship?.cityRank;
            webengage_params.anthe_rank_state = tpResultData?.data?.scholarship?.stateRank;
            webengage_params.anthe_all_India_rank = tpResultData?.data?.scholarship?.allIndiaRank;
            webengage_params.scholarship_percent = tpResultData?.data?.percentage;

            props.setTpResultData(tpResultData.data)
            fetchCourseData()

            // Earlier this data was coming in Dashboard API (Ref:iAcst)
            props.setDashboardData({
                ...props.dashboardInfo,
                scholarship_msg: tpResultData.data?.scholarship?.remarks || "",
                overall_percentage: tpResultData.data?.percentage || "",
                scholarship_percentage: tpResultData.data?.scholarship?.tutionFee || "",
            })
        }
    }, [tpResultData]);
    
    const { main_exam, static_data } = props?.dashboardInfo

    const fetchCourseData = async () => {
        setisProductLoading(true);
        try {

            let courseparams = `${props.profileInfo.classtream.split('&')[0]}/${props.profileInfo.stream}/${props.profileInfo.branch_code}/${props.profileInfo.roll_number}/${props.profileInfo.mobile_number}?term=${props.profileInfo.lead_term}`
            if(main_exam[0]?.career_type){
                courseparams += `&career_type=${main_exam[0].career_type}`
            }

            const res = await courseListing(courseparams);
            if (res.data) {
                setCourseData(res.data);
            }
        } catch (error) {
            console.error('Error fetching course data:', error);
        }

        setisProductLoading(false);
    }

    // setting state for loading result
    useEffect(() => {
        if (isTokenLoading || isResultLoading || isProductLoading) {
            setIsLoading(true);
        } else {
            setIsLoading(false);
        }

    }, [isTokenLoading, isResultLoading, isProductLoading]);
    return (
        <>
            {isLoader ? (<Loader />) : (
                <div className='bg-light'>
                    {static_data.testplayer_down || resultErrors ? (
                        <Container className="p-lg-3 pb-lg-0 pb-xl-3 mh-100 maxw-11">
                            {static_data.testplayer_down ? <TestServerDownMsg msg={static_data.dashboard_msg} /> :
                                <ResultAwaitedCase
                                    cardData={{ ...main_exam[0], report_text: 'Result Awaited' }}
                                    staticData={static_data} profileData={props?.profileInfo}
                                />}
                        </Container>
                    ) : <>
                        {CourseData &&
                            <>
                                <GuidedJourney flags={CourseData?.flags} />
                                {!CourseData?.flags?.course_purchased && 
                                    <Fomo antheFomoDesc={main_exam[0]?.anthe_fomo_desc} />
                                }
                            </>
                        }

                        <Container className="p-lg-3 pb-lg-0 pb-xl-0 mh-100 maxw-11 px-0">
                            {!CourseData?.flags?.course_purchased ?
                                (tpResultData?.data?.scholarship?.status?.toLowerCase() == "qualified" ?
                                    <QualifiedCard
                                        result={tpResultData}
                                        userpsid={
                                            props?.profileInfo?.student_psid || ('T' + (props?.profileInfo?.roll_number?.substr(2)))
                                        }
                                    /> : <NonqualifiedCard />
                                ):(<ResultWavier mainExamData={main_exam[0]} flags={CourseData?.flags} profileData={props.profileInfo} />)
                            }
                        </Container>
                    </>}

                    <Container className="p-lg-3 pb-lg-0 pb-xl-3 mh-100 maxw-11">   
                        <div className='bg-color-w p-lg-4 pb-0 rounded mb-3 p-me-2'>
                            <>
                            <h3 className='text-grey-black font-size-lg mb-3'>Branches near you</h3>
                            <Branchmapsection profileData={props?.profileInfo} token={props?.token} isResultPage={true} />
                            </>   
                        </div>
                        {CourseData?.data?.length ?
                        <CourseListing profileData={props.profileInfo} token={props?.token} CourseData={CourseData} postExam={true} /> : <></>
                        }
                        <Byjus_Advantage profileData={props?.profileInfo} isResultPage={true} token={props?.token} className="mb-2" />
                        <NeetChampionBanner profileData={props?.profileInfo} token={props?.token} />
                        {props?.profileInfo?.anthetwo ? 
                        <Faqtwo profileData={props?.profileInfo} token={props?.token} isResultPage={true} className="mt-2" /> :
                        <Faq profileData={props?.profileInfo} token={props?.token} isResultPage={true} className="mt-2" />}
                    </Container>
                </div >
            )}
        </>
    );
};


export default connect(mapStateToProps, mapDispatchToProps)(ResultPage)